import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

import GearIcon from "./gear.png";       
import LinkIcon from "./link.png";     
import ShieldIcon from "./shield.png"; 
import LockIcon from "./lock.png"; 

const HowItWorksSection = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({ heading: "", content: "" });
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleShowModal = (heading, content) => {
    setModalContent({ heading, content });
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const cards = [
    {
      icon: <img src={GearIcon} alt="Appliance Arrives" className="icon" />,
      heading: "Rapid Deployment: Appliance Arrives",
      preview: "Your enterprise-grade AI appliance is delivered pre-configured to your data center, ready for seamless integration.",
      readMoreContent: "Receive a rack-mountable unit equipped with powerful GPUs, pre-loaded with optimized AI models, and running a hardened operating system. This appliance is designed for maximum security and performance, requiring no internet connection after initial setup. It includes redundant power supplies, RAID storage, and hardware encryption, ensuring data integrity and availability. Our scalable architecture supports deployments from 50 to 50,000 users, adapting to your organization's growing needs.",
    },
    {
      icon: <img src={LinkIcon} alt="Network Integration" className="icon" />,
      heading: "Seamless Integration: Your Network, Your Rules",
      preview: "Connects effortlessly to your existing IT infrastructure, operating autonomously without external cloud dependencies.",
      readMoreContent: "Our solution integrates seamlessly into your existing network infrastructure, supporting robust authentication via LDAP/AD and flexible VLAN configurations. It's firewall-friendly, requiring no outbound connections, and operates in complete harmony with your current security stack. This ensures total network isolation and complete control over your AI environment, aligning perfectly with your internal security policies and compliance mandates.",
    },
    {
      icon: <img src={ShieldIcon} alt="Immediate Value" className="icon" />,
      heading: "Instant Productivity: Immediate Value",
      preview: "Start processing documents and generating insightful queries within hours of deployment, unlocking AI's full potential.",
      readMoreContent: "Access a suite of pre-trained, high-performance AI models immediately, tailored for common enterprise use cases. Our OpenAI-compatible API ensures zero code changes are needed to integrate with your existing applications and workflows. Benefit from built-in Retrieval-Augmented Generation (RAG) capabilities, allowing your AI to provide accurate, source-cited answers from your internal documents. A comprehensive admin dashboard provides real-time usage monitoring and performance analytics.",
    },
    {
      icon: <img src={LockIcon} alt="Complete Sovereignty" className="icon" />,
      heading: "Absolute Control: Complete Sovereignty",
      preview: "Maintain full ownership and control over your data; it never leaves your premises, ensuring unparalleled privacy and security.",
      readMoreContent: "Achieve true data independence with optional air-gapped operation, ensuring complete isolation from external networks. Our platform is designed with zero telemetry and no \"phone-home\" features, preventing any unauthorized data egress. Updates are delivered via secure physical media with cryptographic verification of all components, guaranteeing system integrity. Your data remains exclusively under your control, free from foreign surveillance or cloud vulnerabilities.",
    },
  ];

  return (
    <div id="how-it-works" className="section-container text-dark section-padding">
      <div className="text-center margin-bottom-50">
        <h2 className="section-title text-dark font-weight-700">
          Enterprise AI Without Enterprise Risk: Simplified Deployment, Maximum Security
        </h2>
        <p className="section-description text-medium-gray line-height-1-5">
          Experience a streamlined transition to powerful, on-premise AI. Libertus AI is engineered for rapid deployment, bringing advanced AI capabilities to your organization in as little as 72 hours. Our process is designed for minimal disruption and maximum security, ensuring you gain immediate value without the complex integrations or inherent risks of cloud-based solutions. Discover our straightforward approach to deploying enterprise-grade AI that puts you in complete control.
        </p>
      </div>

      <div className="card-grid">
        {cards.map((card, index) => (
          <div key={index} className={`base-card hover-scale card-animation-on-load ${isVisible ? 'is-visible' : ''}`} style={{ cursor: "pointer" }} onClick={() => handleShowModal(card.heading, card.readMoreContent)}>
            <div className="card-icon" style={{ marginBottom: "20px" }}>{card.icon}</div>
            <h3 className="card-title text-dark">
              {card.heading}
            </h3>
            <p className="card-description text-medium-gray">
              {card.preview}
            </p>
            <a href="#" onClick={(e) => { e.preventDefault(); handleShowModal(card.heading, card.readMoreContent); }} className="resource-card-light-bg-link">
              Read More
            </a>
          </div>
        ))}
      </div>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalContent.heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalContent.content}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default HowItWorksSection;
